import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './styles.scss';

export default function Label({ children }) {
    /* eslint-disable jsx-a11y/label-has-for */
    return (<label className={styles.label}>
        {children}
    </label>);
    /* eslint-enable jsx-a11y/label-has-for */
}

Label.displayName = displayName('Forms/InputGroup/Label');

Label.propTypes = {
    children: PropTypes.node.isRequired,
};
